(function () {
    'use strict';

    angular.module("imApp").factory("equipmentGrpMenuService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 2048,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
